export const COM_TIMEFORMAT = 'YYYY-MM-DD HH:mm:ss';
export const COM_TIMEFORMAT2 = 'YYYY-MM-DDTHH:mm:ss';
export const COM_TIMEFORMAT3 = 'DD/MM/YYYY HH:mm:ss';
export const COM_TIMEFORMAT4 = 'DD/MM/YYYY';
export const COM_TIMEFORMAT5 = 'MMM DD YYYY, HH:mm';